import React from 'react';
import './Select.css';

const Select = ({
  name,
  value,
  onChange,
  onBlur,
  options = [],
  placeholder = 'Select an option',
  label,
  error,
  touched,
  disabled = false,
  required = false,
  className = '',
  ...props
}) => {
  const showError = error && touched;

  return (
    <div className={`select-wrapper ${className} ${showError ? 'has-error' : ''}`}>
      {label && (
        <label className="select-label" htmlFor={name}>
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <div className="select-container">
        <select
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          className="select-field"
          {...props}
        >
          <option value="">{placeholder}</option>
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </option>
          ))}
        </select>
        <span className="select-arrow">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
      </div>
      {showError && <span className="select-error">{error}</span>}
    </div>
  );
};

export default Select;
